import React from 'react';
import styles from 'components/Cards/Cards.module.css';
import { eq } from 'lodash';
import PropTypes from 'prop-types';
import { CreativeCardFooter } from 'components/Cards/CreativeCards/CreativeCardFooter';
import { CreativeCardWrapper } from 'components/Cards/CreativeCards/CreativeCardWrapper';
import { WebPushBody } from 'components/Cards/CreativeCards/CreativeCardPreviewBody/WebPushBody';
import { ArrayUse } from 'lib/ArrayUse';
import NewCurrentCircles from 'assets/img/NewCurrentCircles.png'

export const WebPushCard = ({
    template,
    templateId,
    templateType,
    isShowChainButton,
    isShowUsage,
    redirectPath,
    onClick,
    containerClassName
}) => {
    const { template_unique_id, jinja_fields } = template;

    const jinjaBodyObj = ArrayUse.findCollection(jinja_fields, { jinja_field_name: 'jinja_body' });
    const jinjaMsgTitleObj = ArrayUse.findCollection(jinja_fields, { jinja_field_name: 'jinja_msg_title' });
    const jinjaPushLogoObj = ArrayUse.findCollection(jinja_fields, { jinja_field_name: 'jinja_push_logo' });

    const setDefaultPreviewContent = obj => {
        const { data } = obj;

        if (!data.value) {

            if (eq(data.jinja_field_name, 'jinja_push_logo')) return { ...obj, data: { ...data, value: NewCurrentCircles } }

            return { ...obj, data: { ...data, value: 'Default' } }
        }

        return obj
    };

    const modifiedJinjaFields = ArrayUse.replaceGroup(jinja_fields, [
        setDefaultPreviewContent(jinjaBodyObj),
        setDefaultPreviewContent(jinjaMsgTitleObj),
        setDefaultPreviewContent(jinjaPushLogoObj)
    ]);

    return (
        <CreativeCardWrapper
            isSelected={eq(templateId, template_unique_id)}
            cardType={templateType}
            className={containerClassName}
        >
            <div className={styles.webPushCard} onClick={onClick}>
                <WebPushBody jinja_fields={modifiedJinjaFields}/>
            </div>
            <CreativeCardFooter {...{ template, isShowChainButton, isShowUsage, redirectPath }}/>
        </CreativeCardWrapper>
    );
};

WebPushCard.propTypes = {
    template: PropTypes.object.isRequired,
    templateId: PropTypes.string,
    templateType: PropTypes.string,
    isShowChainButton: PropTypes.bool,
    isShowUsage: PropTypes.bool,
    redirectPath: PropTypes.string,
    onClick: PropTypes.func,
    containerClassName: PropTypes.string
};
WebPushCard.defaultProps = {
    isShowUsage: true,
    containerClassName: ''
};
